import { render } from "./DialogMsg.vue?vue&type=template&id=706cadde&scoped=true"
import script from "./DialogMsg.vue?vue&type=script&lang=js"
export * from "./DialogMsg.vue?vue&type=script&lang=js"

import "./DialogMsg.vue?vue&type=style&index=0&id=706cadde&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706cadde"]])

export default __exports__